import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=bff30442&scoped=true"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=bff30442&prod&scoped=true&lang=css"
import style1 from "./TeamView.vue?vue&type=style&index=1&id=bff30442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff30442",
  null
  
)

export default component.exports